"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiConfig_1 = require("../config/ApiConfig");
var ApiManager_1 = require("../ApiManager");
var ApiUserComic = /** @class */ (function (_super) {
    __extends(ApiUserComic, _super);
    function ApiUserComic() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_GIFT_LIST = 'api/v1/gift/lists';
        _this.GET_LIBRARY_LIST = '/api/v1/page/library';
        _this.DELETE_LIBRARY = '/users/deleteUserComicView';
        _this.GET_SUBSCRIBED_LIST = '/api/v1/page/subscribed';
        _this.DELETE_SUBSCRIBED = '/users/deleteUserSubscribed';
        _this.UPDATE_SUBSCRIBED = '/users/setUserComicInformation';
        _this.getGiftListData = function (token, mature) {
            return ApiConfig_1.Axios.Client({
                header: { token: token, mature: mature },
                method: 'post',
                url: _this.GET_GIFT_LIST,
            });
        };
        /**
         * 내서재 목록 API
         * @param token
         * @returns
         */
        _this.getLirbraryListProc = function (token) {
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'get',
                url: _this.GET_LIBRARY_LIST,
            });
        };
        /**
         * 구독중인 리스트 획득 api
         * @param token
         * @constructor
         */
        _this.getSubscribeListProc = function (token) {
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'get',
                url: _this.GET_SUBSCRIBED_LIST,
            });
        };
        /**
         * 구독하기 요청
         * @param token
         * @param comicId
         * @returns
         */
        _this.updateSubscribedProc = function (token, comicId, subscribed) {
            var data = {
                comicId: comicId,
                subscribed: subscribed,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'post',
                url: _this.UPDATE_SUBSCRIBED,
                data: data,
            });
        };
        /**
         * 내서재에서 삭제 api
         * @param token
         * @param comicIdArray
         * @constructor
         */
        _this.deleteLibrary = function (token, comicIdArray) {
            var data = {
                comicIdArray: comicIdArray,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'post',
                url: _this.DELETE_LIBRARY,
                data: data,
            });
        };
        /**
         * 구독 목록 삭제 api
         * @param token
         * @param comicIdArray
         * @constructor
         */
        _this.deleteSubscribed = function (token, comicIdArray) {
            var data = {
                comicIdArray: comicIdArray,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'post',
                url: _this.DELETE_SUBSCRIBED,
                data: data,
            });
        };
        return _this;
    }
    ApiUserComic.getInstance = function (initValue) {
        if (!ApiUserComic.classInstance) {
            this.classInstance = new ApiUserComic(initValue);
        }
        return this.classInstance;
    };
    return ApiUserComic;
}(ApiManager_1.ApiManager));
exports.default = ApiUserComic;
